import * as React from 'react';



import CharismaTrainingDocs from '../training/trainingDocs.tsx'
import CharismaStudentTrainingDocs from './studentTrainingDocs.tsx'
import CharismaStudentTrainingCertificatonsList from './studentTrainingCertificationsList.tsx';

import Grid from '@mui/material/Grid'


import { CharismaUserContext } from '../context.tsx';

export default function CharismaStudentTrainingBook(props){
    

    

    const lCurrentUser = React.useContext(CharismaUserContext);

    


    return(        
        <Grid container spacing={4}>
            <Grid item xs={12} sm={6}>
                <CharismaStudentTrainingCertificatonsList
                    studentTrainingId={props.studentTrainingId}
                    studentId={props.studentId}
                    readOnly={lCurrentUser.profile !== 0}
                    userProfile = {lCurrentUser.profile}
                    trainingId = {props.trainingId}
                />
            </Grid>                      
            <Grid item xs={12} sm={6}>               
               <CharismaStudentTrainingDocs
                    type="personal"
                    studentTrainingId={props.studentTrainingId}
                    studentId={props.studentId}
                    readOnly={lCurrentUser.profile !== 0 && lCurrentUser.profile !== 3}
                    userProfile={lCurrentUser.profile}
                    studentName = {props.studentName}
                    title={'Documents Personnels'}
                    trainingId = {props.trainingId}
                />
            </Grid>
                 
            <Grid item xs={12} sm={6}>
                <CharismaTrainingDocs
                    type="book"
                    trainingId={props.trainingId}
                    readOnly={true}
                    title={'Documents Administratifs'}
                />
            </Grid>
             
            {lCurrentUser.profile !== 2 ?
                <Grid item xs={12} sm={6}>
                    <CharismaStudentTrainingDocs
                        type="subscribe"
                        studentTrainingId={props.studentTrainingId}
                        studentId={props.studentId}
                        readOnly={lCurrentUser.profile !== 0}
                        userProfile = {lCurrentUser.profile}
                        studentName = {props.studentName}
                        title={'Documents d\'Inscription'}
                        trainingId = {props.trainingId}
                    />
                </Grid>
                :
                null
            }
                      
        </Grid>       
                          
    );
    
    
}